<template>
  <v-container class="mt-3">
    <v-row>
      <v-col cols="12 my-3">
        <p class="text-center f-xl f-bold" data-lang="telephone_title">
          {{ title || telTitle() }}
        </p>
        <p
          class="text-gray text-center"
          data-lang="email_subtitle"
          v-if="form.login_type == 2"
          style="white-space: pre-line"
          v-text="formattedEmailSubTitle"
        ></p>
        <p
          class="text-gray text-center"
          data-lang="telephone_subtitle"
          style="white-space: pre-line"
          v-text="formattedTelSubTitle"
          v-else
        ></p>
      </v-col>

      <v-col cols="12">
        <InputTelephoneWithCountry
          v-if="form.login_type == 1"
          v-model:value="form.Telephone"
          :textFloat="$t('telephone')"
          :placeholder="$t('telephone')"
          type="number"
          name="telephone"
          size="lg"
          isRequired
          @onkeypress="isNumber($event)"
          :isValidate="isValidate"
          :v="v"
          class="f-regular"
          inputmode="numeric"
          v-model:country="form.telephone_country_id"
          v-model:code="form.telephone_code"
          :disabledCountry="disabledCountry"
        />

        <InputText
          v-if="form.login_type == 2"
          v-model:value="form.Email"
          :textFloat="$t('email')"
          :placeholder="$t('email')"
          type="text"
          name="email"
          size="lg"
          isRequired
          :isValidate="isValidateEmail"
          :v="vEmail"
          class="f-regular"
        />
      </v-col>
      <v-col
        class="text-center"
        v-if="$config.display_email_login == '1' && show"
      >
        <span
          class="text-underline"
          @click="$emit('emailLogin', 2)"
          v-if="form.login_type == 1"
          data-lang="email_login_message"
        >
          {{ $t("email_login_message") }}</span
        >
        <span
          class="text-underline"
          @click="$emit('emailLogin', 1)"
          v-if="form.login_type == 2"
          data-lang="telephone_login_message"
        >
          {{ $t("telephone_login_message") }}
        </span>
      </v-col>
    </v-row>

    <div
      class="register-bottom fixed-bottom shadow"
      :class="{ 'bg-white': !lineLayout.includes('Minimal') }"
    >
      <c-btn
        type="button"
        block
        variant="confirm-primary"
        @click="$emit('ValidateTelephone')"
        >{{ $t("confirm") }}</c-btn
      >

      <c-btn
        class="mt-2"
        block
        type="button"
        variant="outline-primary"
        v-if="$store.state.editPhonenumber && lineLayout == 'Compact'"
        @click="
          $router.replace('/manage'), $store.commit('setEditPhoneNumber', false)
        "
        >{{ $t("cancel") }}
      </c-btn>
    </div>
  </v-container>
</template>

<script>
import ValidateTelephone from "@/mixins/validateTelephone";
export default {
  mixins: [ValidateTelephone],

  computed: {}
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.pos-fix {
  position: fixed;
}
</style>
